import { gql } from '@apollo/client'

export const GET_CAMPAIGN_VAST_REQUEST_MULTIPLIER = gql`
  query campaignVastRequestMultipliers($campaignId: ID!) {
    campaignVastRequestMultipliers(campaignId: $campaignId) {
      multiplier
      errors
    }
  }
`
